/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { GetFailedWorkOrderLogResponse } from '../models/get-failed-work-order-log-response';
import { GetWorkOrderLogResponse } from '../models/get-work-order-log-response';
import { ProcessStatus } from '../models/process-status';

/**
 * work order logs api
 */
@Injectable({ providedIn: 'root' })
export class WorkOrderLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllWorkOrderLogs()` */
  static readonly GetAllWorkOrderLogsPath = '/api/v1/work-order-logs';

  /**
   * Get list of uploaded work order logs.
   *
   * Gets the list of all uploaded work order logs . <br>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllWorkOrderLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllWorkOrderLogs$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a filter to the work order logs list
       *  - process status
       */
      'work order log by status'?: ProcessStatus;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetWorkOrderLogResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WorkOrderLogService.GetAllWorkOrderLogsPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query(
        'work order log by status',
        params['work order log by status'],
        {}
      );
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetWorkOrderLogResponse>;
        })
      );
  }

  /**
   * Get list of uploaded work order logs.
   *
   * Gets the list of all uploaded work order logs . <br>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllWorkOrderLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllWorkOrderLogs(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a filter to the work order logs list
       *  - process status
       */
      'work order log by status'?: ProcessStatus;
    },
    context?: HttpContext
  ): Observable<GetWorkOrderLogResponse> {
    return this.getAllWorkOrderLogs$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetWorkOrderLogResponse>
        ): GetWorkOrderLogResponse => r.body
      )
    );
  }

  /** Path part for operation `getAllFailedWorOrderLogs()` */
  static readonly GetAllFailedWorOrderLogsPath =
    '/api/v1/work-order-logs/failed';

  /**
   * Get list of uploaded work order failed logs by file.
   *
   * Gets the list of uploaded work order failed logs by file . <br>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllFailedWorOrderLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllFailedWorOrderLogs$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * this adds a long search to the following fields:
       *   - workOrderFileId
       */
      WorkOrderFileId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetFailedWorkOrderLogResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WorkOrderLogService.GetAllFailedWorOrderLogsPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('WorkOrderFileId', params.WorkOrderFileId, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetFailedWorkOrderLogResponse>;
        })
      );
  }

  /**
   * Get list of uploaded work order failed logs by file.
   *
   * Gets the list of uploaded work order failed logs by file . <br>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllFailedWorOrderLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllFailedWorOrderLogs(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * this adds a long search to the following fields:
       *   - workOrderFileId
       */
      WorkOrderFileId?: number;
    },
    context?: HttpContext
  ): Observable<GetFailedWorkOrderLogResponse> {
    return this.getAllFailedWorOrderLogs$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetFailedWorkOrderLogResponse>
        ): GetFailedWorkOrderLogResponse => r.body
      )
    );
  }
}
